import {
  entityKeys,
  entityModelFactory,
  generateContent,
} from '../../entity-data/entity.model';

export const CONTENT_SCHEMA = Object.freeze({
  BILLING_NAME: '',
  EMAIL: '',
});

const KEYS: any = entityKeys({}, CONTENT_SCHEMA);
export const CONTENT_KEYS: any = generateContent(CONTENT_SCHEMA).KEYS;

export class ClientPreview extends entityModelFactory(
  {},
  null,
  CONTENT_SCHEMA,
  null
) {
  static KEYS: any = KEYS;
  static CONTENT_KEYS: any = CONTENT_KEYS;

  get billingName(): string {
    return this.getFieldInContent(CONTENT_KEYS.BILLING_NAME);
  }

  get email(): string {
    return this.getFieldInContent(CONTENT_KEYS.EMAIL);
  }

  isDeleted(): boolean {
    return this.header.state === 'deleted';
  }
}
